import { Toaster } from "sonner";

import styles from "./SnackbarToaster.module.css";

export const SNACKBAR_TOASTER_ID = "snackbar";

export const SnackbarToaster = () => (
  <Toaster
    id={SNACKBAR_TOASTER_ID}
    position="top-left"
    theme="dark"
    gap={8}
    toastOptions={{ className: styles.wrapper }}
  />
);
